
const observer = new MutationObserver(mutations => {
  mutations.forEach(({ addedNodes }) => {
    addedNodes.forEach(node => {
      if (node.nodeType === 1) {
        if (node.tagName === "IFRAME") {
          if (node.src.includes("youtube.com") || node.src.includes("vimeo.com")) {
            node.setAttribute("loading", "lazy");
            node.setAttribute("data-src", node.src);
            node.removeAttribute("src");
          }
        } else if (node.tagName === "LINK") {
          if (node.href.includes("place") || 
              node.href.includes("font-awesome.min.css") ||
              node.href.includes("vimeo.com") ||
              node.href.includes("mlveda-currencies-style.css"))            
          {
            node.setAttribute("data-href", node.href);
            node.removeAttribute("href");
          }
        } else if (node.tagName === "IMG" && !node.src.includes("data:image")) {
          node.setAttribute("loading", "lazy");
        } else if (node.tagName === "SCRIPT") {
           
          
            if (node.getAttribute("type") == "module" ||
              node.src.includes("trustbadge.js") ||              
              node.innerText.includes("trustbadge") ||
              node.innerText.includes("trustedshops_shopify") ||
              node.innerText.includes("trustbadge") ||
              node.src.includes("trustedshops_shopify") ||
              node.src.includes("shopify/assets/themes_support") ||
              node.src.includes("cdn.shopify.com") ) {
      
            // do nothing
            //return
          } else if (node.className === "analytics" || node.className === "boomerang") {
            node.type = "text/lazyload";
          } else if (node.innerHTML.includes("asyncLoad")) {
            node.innerHTML = node.innerHTML
              .replace("if(window.attachEvent)", "document.addEventListener('asyncLazyLoad',function(event){asyncLoad();});if(window.attachEvent)")
              .replace(/, asyncLoad/g, ', function(){}');
          } else if (node.innerHTML.includes("PreviewBarInjector") || node.innerHTML.includes("adminBarInjector")) {
            node.innerHTML = node.innerHTML.replace("DOMContentLoaded", "asyncLazyLoad");
          } else if (
            node.src.includes("assets/storefront") ||
            node.src.includes("assets/shopify_pay/") ||
            node.src.includes("gdpr_cookie") ||
            node.src.includes("/pages/v1/pages.js") ||
            node.src.includes("widgets.automizely.com") ||              
            node.src.includes("script.hotjar") ||
            node.src.includes("mlveda-currencies-switcher") ||
            node.src.includes("checker.js")
          ) {
            node.setAttribute("data-src", node.src);
            node.removeAttribute("src");
          } else if (
            node.innerText.includes("hotjar") ||
            node.innerText.includes("anglerfox") ||
            node.innerText.includes("automizely") ||
            node.innerText.includes("pages/v1/pages.js") ||
            node.innerText.includes("tracker") ||
            node.innerText.includes("webPixelsManager") ||
            node.innerText.includes("fera") ||
            node.innerText.includes("gtm.start")
          ) {
            node.type = "text/lazyload";
          }
        }
      }
    });
  });
});


observer.observe(document.documentElement, {
    childList: true,
    subtree: true
});

class ShadowRoot extends HTMLElement {
    constructor() {
        super();

        this._shadowRoot = this.attachShadow({ mode: "open" });
        this._shadowRoot.innerHTML = '<style>:host img { pointer-events: none; position: absolute; top: 0; left: 0; width: 100%; height: 99vh; max-width: 99vw; max-height: 99vh;</style><img id="shadow" alt=""/>';
    }

    connectedCallback() {
        this._fullImageEl = this._shadowRoot.querySelector("#shadow");
        this._fullImageEl.src = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8000 8000'%3E%3C/svg%3E";
    }
}

customElements.define("shadow-root", ShadowRoot);

document.head.insertAdjacentHTML("afterend", `<shadow-root></shadow-root>`);
